import { render, staticRenderFns } from "./CampoPhone.vue?vue&type=template&id=3f4d3e38&scoped=true&"
import script from "./CampoPhone.vue?vue&type=script&lang=js&"
export * from "./CampoPhone.vue?vue&type=script&lang=js&"
import style0 from "./CampoPhone.vue?vue&type=style&index=0&id=3f4d3e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4d3e38",
  null
  
)

export default component.exports